import type { ErrorMessages } from "@fola/schemas/user"
import type { LiteralKeys } from "@fola/utils/types"

const error: LiteralKeys<ErrorMessages> = {
	changeNotAllowed: "This field cannot be changed.",
	changeBySelfNotAllowed: "You do not have permission to change the admin status of this user.",
	newPasswordMismatch: "The new passwords do not match.",
	oldPasswordIncorrect: "The old password is incorrect.",
	passwordChangeIncomplete: "To change the password, you have to fill out all three password fields.",
}

const strings = {
	error,
	username: "Username",
	email: "Email",
	displayName: "Display name",
	changePassword: "Change password",
	oldPassword: "Old password",
	newPassword: "New password",
	newPasswordRepeat: "Repeat new password",
	theme: "Theme",
	save: "Save",
	isAdmin: "You are an administrator.",
	settingsSaved: "Your settings were saved.",
	settingsSavedTitle: "Settings saved",
}

export default strings
export type UserL10nStrings = typeof strings
